import { createApp } from 'vue';

import SlideForm from '@/javascripts/components/top_form.vue';
createApp(SlideForm).mount('#app');